import cn from 'clsx';
import { FC, HTMLAttributes } from 'react';

import s from './LineDivider.module.scss';

export type LineDividerProps = HTMLAttributes<HTMLElement>;

const LineDivider: FC<React.PropsWithChildren<React.PropsWithChildren<LineDividerProps>>> = ({ className, ...props }) => {
  return <hr className={cn(s.divider, className)} {...props} />;
};

export default LineDivider;
